import { useProjectContext } from "@hooks/context/useProjectContext";
import { ProjectProvider } from "@hooks/context/useProjectContext";
import ScrollToTop from "@ui/atoms/ScrollToTop/ScrollToTop";
import NotificationDrawer from "@layout/NotificationDrawer/NotificationDrawer";
import { userHasLevel1OnlyAccess } from "@utils/projectAccess";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { MainPageLayout } from "@layout/MainPageLayout";
import { MainSectionLayout } from "@layout/MainSectionLayout";
import { resolveProjectSelectedItem } from "../selectedItem";
import ProjectLayoutSidebarWrapper from "./ProjectLayoutSidebarWrapper";

// Reads project context to scope the notification feed: Level1Only users get
// the report-submission-only "shared-project" lens; everyone else the full feed.
const ProjectNotificationDrawer = () => {
  const { selectedProject } = useProjectContext();
  return (
    <NotificationDrawer
      context={
        userHasLevel1OnlyAccess(selectedProject) ? "shared-project" : "project"
      }
    />
  );
};

export interface Props {
  children: React.ReactNode;
}
const ProjectDashboardLayout = ({ children }: Props) => {
  const location = useLocation();
  // Initialise from the current path to avoid a first-render "no selection" flash.
  const [selectedItem, setSelectedItem] = useState(() =>
    resolveProjectSelectedItem(location.pathname)
  );

  useEffect(() => {
    setSelectedItem(resolveProjectSelectedItem(location.pathname));
  }, [location.pathname]);

  return (
    <ProjectProvider>
      <ScrollToTop />
      <MainPageLayout>
        <ProjectLayoutSidebarWrapper
          selectedItem={selectedItem}
          setSelectedItem={setSelectedItem}
        />

        <MainSectionLayout>{children}</MainSectionLayout>
      </MainPageLayout>
      <ProjectNotificationDrawer />
    </ProjectProvider>
  );
};

export default ProjectDashboardLayout;
